import { BrowserUtils } from 'utils/browser';

/**
 * iOS ignores `volume` and blocks the added track from starting alongside the
 * video, so the track and video mix cannot be previewed there.
 */
export function isAudioMixPreviewSupported(): boolean {
  return !BrowserUtils.isIOS();
}
